import {} from './analytics';
import Swiper from 'swiper/swiper-bundle.min.js';
import 'swiper/swiper-bundle.min.css';


const main = () => {
  // animations

  document.querySelector('.offer__wrapper').classList.add('visible');

  if (window.innerWidth < 1280) {
    var textBtn = document.querySelectorAll('.slider__info>.btn');

    for (let f = 0; f < textBtn.length; f++) {
      textBtn[f].innerHTML = "Открыть Axiom";
    }
  }

  window.addEventListener('scroll', function() {
    scrollPosition = window.scrollY;

    var startSection = document.querySelector('.start');
    var startSectionPosition = startSection.offsetTop;
    var startSectionHeight = startSection.offsetHeight;

    var processSection = document.querySelector('.process');
    var processSectionPosition = processSection.offsetTop;
    var processSectionHeight = processSection.offsetHeight;

    var sliderSection = document.querySelector('.slider');
    var sliderSectionPosition = sliderSection.offsetTop;
    var sliderSectionHeight = sliderSection.offsetHeight;

    var securitySection = document.querySelector('.security');
    var securitySectionPosition = securitySection.offsetTop;
    var securitySectionHeight = securitySection.offsetHeight;

    var advantageFirst = document.querySelector('.advantage--first');
    var advantageSecond = document.querySelector('.advantage--second');
    var advantageFirstPosition = advantageFirst.offsetTop;
    var advantageSecondPosition = advantageSecond.offsetTop;

    if (scrollPosition >= advantageFirstPosition / 2) {
      advantageFirst.classList.add('animated');
    }

    if (scrollPosition >= advantageSecondPosition / 1.3) {
      advantageSecond.classList.add('animated');
    }

    if (scrollPosition >= startSectionPosition - 200) {
      startSection.classList.add('animated');
    }

    if (window.innerWidth > 1024) {
      var documentHeight = document.body.offsetHeight;
      var scrollPosition = window.scrollY;

      if (scrollPosition >= sliderSectionHeight + sliderSectionPosition / 2) {
        sliderSection.classList.add('animated');
      }

      if (scrollPosition >= processSectionPosition - 200) {
        processSection.classList.add('animated');
      }

      if (scrollPosition >= securitySectionPosition - 500) {
        securitySection.classList.add('animated');
      }
    } else {
      var processSection = document.querySelector('.process');
      var processSectionPosition = processSection.getBoundingClientRect().top + window.scrollY;
      var processSectionHeight = processSection.offsetHeight;

      var securitySection = document.querySelector('.security');
      var securitySectionPosition = securitySection.getBoundingClientRect().top + window.scrollY;
      var securitySectionHeight = securitySection.offsetHeight;

      var sliderSection = document.querySelectorAll('.slider .swiper-slide');

      for (let i = 0; i < sliderSection.length; i++) {
        var sliderSectionPosition = sliderSection[i].getBoundingClientRect().top + window.scrollY;
        var sliderSectionHeight = sliderSection[i].offsetHeight;

        if (scrollPosition >= sliderSectionPosition - 100) {
          sliderSection[i].classList.add('animated');
        }
      }

      if (scrollPosition >= processSectionPosition - 300) {
        processSection.classList.add('animated');
      }

      if (scrollPosition >= securitySectionPosition - 500) {
        securitySection.classList.add('animated');
      }
    }
  });
  // end of animations

  // slideToggle
  const linkToggle = document.querySelectorAll('.js-toggle');

  for (let i = 0; i < linkToggle.length; i++) {
    linkToggle[i].addEventListener('click', function(event) {
      event.preventDefault();
      const linkToggleCur = document.querySelector('.js-toggle');
      const container = document.getElementById(this.dataset.container);

      if (!container.classList.contains('active')) {
        event.target.classList.add('active');
        container.classList.add('active');
        container.style.height = 'auto';

        const height = `${container.clientHeight}px`;

        container.style.height = '0px';
        setTimeout(() => {
          container.style.height = height;
        }, 0);
      } else {
        container.style.height = '0px';
        event.target.classList.remove('active');
        container.addEventListener('transitionend', () => {
          container.classList.remove('active');
        }, {
          once: true,
        });
      }
    });
  }
  // end slideToggle

  var startVideoTag = document.querySelector('.offer__video--start video');
  // startVideoTag.play();

  setTimeout(function() {
    var loopedVideo = document.querySelector('.offer__video--looped video');
    var startVideo = document.querySelector('.offer__video--start');

    var startVideoDuration = startVideoTag.duration;

    startVideo.classList.add('hidden');
    loopedVideo.play();
  }, 14705);

  const toTop = document.querySelector('.footer__bottom-arrow');

  toTop.addEventListener('click', () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  });

  if (window.innerWidth > 767) {
    new Swiper(".mySwiper", {
      effect: 'fade',
      speed: 500,
      parallax: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
};

if (document.readyState !== 'loading') {
  main();
} else {
  document.addEventListener('DOMContentLoaded', main);
}